"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyledQueryListSectionSkeleton = exports.HeaderSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _searchPreviewProduct = require("@ori/search-preview-product");
var _styles = require("../styles");
const HeaderSkeleton = exports.HeaderSkeleton = (0, _mui.styled)(_styles.UnifiedSkeleton)((param)=>{
    let { theme } = param;
    return {
        width: 215,
        height: '3rem',
        [theme.breakpoints.up('md')]: {
            height: '3.5rem'
        }
    };
});
const StyledQueryListSectionSkeleton = exports.StyledQueryListSectionSkeleton = (0, _mui.styled)(_searchPreviewProduct.QueryListSectionSkeleton)((param)=>{
    let { theme } = param;
    return {
        [".".concat(_searchPreviewProduct.queryListSectionClasses.sectionLabel)]: {
            margin: theme.spacing(0, 3)
        },
        [".".concat(_searchPreviewProduct.queryListSectionClasses.queries)]: {
            margin: theme.spacing(0, 3)
        }
    };
});
